<template>
  <div
    class="drawer-info d-flex"
    data-ui-section="drawer-info"
    :class="{
      'drawer-info--opened': shouldShowVideoList,
    }"
  >
    <div
      class="
        drawer-info__child
        text-white m-4 w-100
      "
    >
      <DrawerInfoHead
        class="mb-3"
        :type="type"
        :author="author"
        :public-url="publicUrl"
        v-on="$listeners"
      />

      <DrawerInfoContent
        :title="title"
      />
    </div>
    <div
      class="
        drawer-info__action
        d-flex d-md-none justify-content-center align-items-center p-4
      "
      @click="shouldShowVideoList = !shouldShowVideoList"
    >
      <i
        class="material-icons"
        :data-icon="shouldShowVideoList ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
      />
    </div>
  </div>
</template>

<script>
import DrawerInfoHead from './DrawerInfoHead';
import DrawerInfoContent from './DrawerInfoContent';

export default {
  components: {
    DrawerInfoHead,
    DrawerInfoContent,
  },
  props: {
    type: {
      type: String,
      default: 'playlist',
    },
    author: {
      type: Object,
      default: undefined,
    },
    publicUrl: {
      type: String,
      default: undefined,
    },

    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      shouldShowVideoList: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.drawer-info {
  background-color: rgba(black, 0.3);
}

.drawer-info__child {
  min-width: 0;
  overflow: hidden;
}
</style>

<style lang="scss">
.drawer-info + .video-collection-drawer__col {
  display: none;

  // TODO: Use bootstraps's media query
  @media (min-width: 768px) {
    display: block;
  }
}
.drawer-info.drawer-info--opened + .video-collection-drawer__col {
  display: block;
}
</style>
